/* eslint-disable @typescript-eslint/no-explicit-any */
import { UserPreferences } from '@scenario/models/user-preferences.model';

export class UserPreferencesMapper {
  mapToDomainModel(dto: UserPreferences) {
    return {
      unitId: dto.unitId,
      unitCurrency: dto.unitCurrency,
      unitTerm: dto.unitTerm,
      unitRealYear: dto.unitRealYear,
      advanced: dto.advanced,
      display: dto.display,
    };
  }
}
